// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import { useTranslation } from 'react-i18next';
import UserSecurityList from 'components/organisms/UserSecurityList';

const UserSecurity = () => {
  const { t } = useTranslation();

  return (
    <PrimaryTemplate h1={t('user_security.header')}>
      <UserSecurityList />
    </PrimaryTemplate>
  );
};

export default UserSecurity;
